















import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class TheThgUnauthenticatedList extends Vue {
  color = this.$store.state.config.color;

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  notAuthenticatedItems = [
    {
      text: "navigation.TheAboutList.home",
      link: "/",
      icon: "mdi-home-outline"
    },
    {
      text: "navigation.TheAboutList.login",
      link: "/login",
      icon: "mdi-login"
    },
    {
      text: "navigation.TheAboutList.signUp",
      link: "/sign-up",
      icon: "mdi-account-plus-outline"
    }
  ];
}
